<template>
  <button
    type="button"
    class="ui-icon-control terminal-icon-control"
    :class="[
      `ui-icon-control--${size}`,
      `ui-icon-control--${variant}`,
      {
        'is-active': active,
        'is-disabled': disabled,
        'terminal-control-click-flash': flashing
      }
    ]"
    :title="$t(title)"
    :aria-label="$t(ariaLabel || title)"
    :aria-pressed="toggle ? String(active) : null"
    :disabled="disabled"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <i v-if="icon" :class="icon"></i>
    <slot />
  </button>
</template>

<script>
export default {
  name: 'UiIconControl',
  inheritAttrs: false,
  props: {
    icon: { type: [String, Array, Object], default: '' },
    title: { type: String, default: '' },
    ariaLabel: { type: String, default: '' },
    active: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    flashing: { type: Boolean, default: false },
    toggle: { type: Boolean, default: false },
    size: {
      type: String,
      default: 'regular',
      validator: value => ['small', 'regular'].includes(value)
    },
    variant: {
      type: String,
      default: 'standard',
      validator: value => ['standard', 'ghost', 'footer'].includes(value)
    }
  }
}
</script>

<style lang="scss">
.terminal-icon-control.ui-icon-control--small {
  width: var(--ui-icon-control-size-small);
  min-width: var(--ui-icon-control-size-small);
  height: var(--ui-icon-control-size-small);
  min-height: var(--ui-icon-control-size-small);
}

.terminal-icon-control.ui-icon-control--small > i {
  width: var(--ui-icon-control-icon-size-small);
  height: var(--ui-icon-control-icon-size-small);
  font-size: var(--ui-icon-control-icon-size-small) !important;
}

.terminal-icon-control.ui-icon-control--ghost {
  border-color: transparent;
  background: transparent;
  box-shadow: none;
}

.terminal-icon-control.ui-icon-control--footer {
  width: 100%;
  min-width: 100%;
  height: 100%;
  min-height: 100%;
  border: 0;
  border-radius: 0;
  background: transparent;
  box-shadow: none;
}

.terminal-icon-control.ui-icon-control--footer > i {
  width: 28px;
  height: 28px;
  font-size: 28px !important;
}

@media (hover: hover) and (pointer: fine) {
  .terminal-icon-control.ui-icon-control--footer:hover {
    background: var(--ui-bg-panel-elevated);
  }
}
</style>
